import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroBanners } from '@/mocks/comics';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % heroBanners.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + heroBanners.length) % heroBanners.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative w-full h-[420px] md:h-[580px] overflow-hidden" aria-label="推荐横幅">
      {heroBanners.map((banner, index) => (
        <div
          key={banner.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100 z-10' : 'opacity-0 z-0'
          }`}
        >
          <img
            src={banner.image}
            alt={banner.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
        </div>
      ))}

      <div className="relative z-20 w-full h-full flex flex-col items-center justify-center px-4">
        <div className="text-center max-w-2xl">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-3 leading-tight">
            {heroBanners[current].title}
          </h2>
          <p className="text-sm md:text-base text-white/80 mb-6">
            {heroBanners[current].subtitle}
          </p>
          <Link
            to={`/comic/${heroBanners[current].comicId}`}
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            立即阅读
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <button
        type="button"
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-30 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-sm transition-colors duration-200 cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-white text-lg md:text-xl"></i>
      </button>
      <button
        type="button"
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-30 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-sm transition-colors duration-200 cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-white text-lg md:text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-30 flex items-center gap-2">
        {heroBanners.map((_, index) => (
          <button
            key={index}
            type="button"
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              index === current ? 'bg-white w-6' : 'bg-white/50 hover:bg-white/70'
            }`}
            aria-label={`跳转到第 ${index + 1} 张`}
          />
        ))}
      </div>
    </section>
  );
}